import React, { useState } from "react";
import ReactApexChart from "react-apexcharts";

const ProjectGraph =({ projects }) => {
    const categories = projects?.map(project => project.title);
    const estimatedCost = projects?.map(project => parseFloat(project.estimation_amount) || 0);
    const generatedCost = projects?.map(project => parseFloat(project.paid_amount) || 0);
  
    while (categories.length < 7) {
      categories.push(` `);
      estimatedCost.push(0);
      generatedCost.push(0);
    }

    const series = [
      {
        name: "Estimated Cost",
        data: estimatedCost,
      },
      {
        name: "Paid Cost",
        data: generatedCost,
      },
    ];
  
    const maxYValue = Math.max(...estimatedCost, ...generatedCost);
  
    const chartOptions = {
      chart: {
        type: "bar",
        height: 350,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "30%",
          borderRadius: 1,
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      xaxis: {
        categories: categories,
        title: {
          text: "Projects",
        },
      },
      yaxis: {
        title: {
          text: "Amount (RO thousands)",
        },
        max: maxYValue,
      },
      fill: {
        opacity: 1,
      },
      tooltip: {
        y: {
          formatter: (val) => `RO ${val} thousands`,
        },
      },
    };
  
    return (
      <div>
        <div id="chart">
          <ReactApexChart options={chartOptions} series={series} type="bar" height={350} />
        </div>
      </div>
    );
  };

export default ProjectGraph;
